import { i18next } from '@yola/ws-sdk';

const validateRequiredField = (value) => (value ? null : i18next.t('This field is required'));

export default validateRequiredField;
